// extracted by mini-css-extract-plugin
export var button = "_51-0";
export var icon = "_51-1";